import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PaginationState {
  itemsPerPage: number;
  setItemsPerPage: (itemsPerPage: number) => void;
}

export const usePaginationStore = create<PaginationState>()(
  persist(
    (set) => ({
      itemsPerPage: 50, // Default value
      setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
    }),
    {
      name: 'pagination-storage',
    }
  )
);